module.exports = __webpack_public_path__ + "static/media/22ESCWA13.0e15a586.jpg";